import axiosInstance from "./index";

/** POST 로그인 */
export function logInApi(data: { user_id: string; password: string }) {
  return axiosInstance
    .post("/admin/signin", data)
    .then((response) => response.data);
}
